import locationsConfig, {
    moduleName as locationsModuleName,
} from "./Locations/config";
import locationGroupsConfig, {
    moduleName as locationGroupsModuleName,
} from "./LocationGroups/config";
import permissionsConfig, {
    moduleName as permissionsModuleName,
} from "./Permissions/config";
import { registerRoutings } from "rootRouting";
import { permissionsType, routingType } from "types/configTypes";
import { registerProjects } from "rootProjects";
import AsyncComponent from "ui/AsyncComponent";
import translateConfig, {
    moduleName as translateModuleName,
} from "./Translate/config";
import { registerModule } from "moduleConfig";
import IConfig from "interfaces/IConfig";
import ProjectContext from "app/App/context";

export const moduleName = "BackofficePayment";
export const url = `/backofficepayment`;

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    const routingChildrens = [];

    // register Settings module
    const locations = locationsConfig(permissions, url);
    if (locations.config.active) {
        config.active = true;

        registerModule(locationsModuleName, locations.config);
        routingChildrens.push(...locations.routing);
    }

    // register LocationGroups module
    const locationGroups = locationGroupsConfig(permissions, url);
    if (locationGroups.config.active) {
        config.active = true;

        registerModule(locationGroupsModuleName, locationGroups.config);
        routingChildrens.push(...locationGroups.routing);
    }

    // register permissions module
    const permissionsModule = permissionsConfig(permissions, url);
    if (permissionsModule.config.active) {
        config.active = true;

        registerModule(permissionsModuleName, permissionsModule.config);
        routingChildrens.push(...permissionsModule.routing);
    }

    //register Translate module
    const tr = translateConfig(permissions, url);
    if (tr.config.active) {
        config.active = true;
        registerModule(translateModuleName, tr.config);
        routingChildrens.push(...tr.routing);
    }

    if (routingChildrens.length) {
        routing.push({
            path: url + "/*",
            children: routingChildrens,
            element: (
                <ProjectContext.Provider
                    value={{ project: "backofficepayment", url }}
                >
                    <AsyncComponent path="BackofficePayment/index" />{" "}
                </ProjectContext.Provider>
            ),
        });
    }

    if (config.active) {
        registerProjects([
            {
                id: moduleName,
                name: "Backoffice Payment",
                icon: "payment",
                url: `${url}`,
                priority: 451,
            },
        ]);
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
